import { BidMode,BidModeList } from "../enums/bid-mode.enum";
import { ISample, Sample } from "./ISample";
import { IBidReference } from "./IBidReference";
import { Utils } from '../Utils';

export interface IBid {
  bidName: string;
  bidId: string;
  bidExpirationDate: Date;
  bidMode: string;
  bidReference: IBidReference;
  bidSupportEmail: string;
  bidCurrency: string;
  billingEntity: string;
  jobNumberInternal: string;
  jobNumberExternal: string;
  showClicks: boolean;
  showOverlap: boolean;
  useResponseCache: boolean;
  testMode: boolean;
  dateCreated: Date;
  dateUpdated: Date;
  standardProduct: boolean;
  _correlationId: string;
  feasibilities: Array<ISample>;
  sampleOneApiCompatible: boolean;
  trackerRequestType: string;
  trackerPeriod: string;
  waves: number;
  budgetInSingleWave: boolean;
  skipOverlaps: boolean;
  panelCheckTargetingMode: string;
}

export class Bid implements IBid {
  bidName: string;
  bidId: string;
  bidExpirationDate: Date;
  bidMode: string;
  billingEntity: string;
  bidCurrency: string;
  bidSupportEmail: string;
  bidReference: IBidReference;
  jobNumberInternal: string;
  jobNumberExternal: string;
  showClicks: boolean;
  showOverlap: boolean;
  useResponseCache: boolean;
  testMode: boolean;
  standardProduct: boolean;
  _correlationId: string;
  dateCreated: Date;
  dateUpdated: Date;
  feasibilities: Array<ISample>;
  sampleOneApiCompatible: boolean;
  trackerRequestType: string;
  trackerPeriod: string;
  waves: number;
  budgetInSingleWave: boolean;
  skipOverlaps: boolean;
  panelCheckTargetingMode:string;

  constructor() {
    this.bidId = Utils.generateUUID();
    this.bidName = Utils.generateUUID();
    this.bidExpirationDate = null;
    this.jobNumberInternal = "";
    this.jobNumberExternal = "";
    this.showOverlap = false;
    this.showClicks = false;
    this.bidMode = BidModeList[BidMode.Precommissioning].name;
    this.bidCurrency = "EUR";
    this.billingEntity = null;
    this.feasibilities = [new Sample()];
    this.testMode = true;
    this.bidSupportEmail = null;
    this.bidReference = { client: "FizzyUI", email: "not@set.com" };
    this.standardProduct = true;
    this.trackerRequestType = "";
    this.trackerPeriod = "";
    this.panelCheckTargetingMode = "Targeted";
    this.budgetInSingleWave = false;

  }

}



// WEBPACK FOOTER //
// ./src/app/models/IBid.ts